/**
 * check Is Custom Tg Present
 * TgAttr And PoiTypes
 */
export function checkIsCustomTgPresent(data = {}) {
  // data
  const { tgAttributesIds = [], poiTypeIds = [] } = data || {};

  // checking data
  const isTgAttributesSelected = tgAttributesIds.length > 0;
  const isPoiTypesSelected = poiTypeIds.length > 0;

  return isTgAttributesSelected || isPoiTypesSelected;
}

// get Custom Tg PoiLayers
export function getCustomTgPoiLayers(
  targetGroupAttrs = {},
  tgAttributesIds = [],
  poiTypeIds = []
) {
  const finalResPoiLayers = [];

  // data check
  const isTgAttrSelected = tgAttributesIds.length > 0;
  const isPoiTypesSelected = poiTypeIds.length > 0;

  // if no custom tg selected for campaign
  if (tgAttributesIds.length === 0 && poiTypeIds.length === 0) {
    return finalResPoiLayers;
  }

  // pushing poiTypeIds
  if (isPoiTypesSelected) {
    finalResPoiLayers.push(...poiTypeIds);
  }

  // pushing poiLayers from tgAttributes selected
  // flattened array for all attributes
  if (isTgAttrSelected) {
    const flattenedTgAttrsAttrs = Object.values(targetGroupAttrs).flat();

    flattenedTgAttrsAttrs.forEach((attribute) => {
      const { id, poiBrandIds = {} } = attribute;

      // only add when tg attribute is selected for campaign
      if (tgAttributesIds.includes(id)) {
        const poiBrandIdsArray = Object.keys(poiBrandIds);
        finalResPoiLayers.push(...poiBrandIdsArray);
      }
    });
  }

  return finalResPoiLayers;
}
